import { render, staticRenderFns } from "./emailOpenOrdersModal.vue?vue&type=template&id=f5b28364&scoped=true&"
import script from "./emailOpenOrdersModal.vue?vue&type=script&lang=js&"
export * from "./emailOpenOrdersModal.vue?vue&type=script&lang=js&"
import style0 from "./emailOpenOrdersModal.vue?vue&type=style&index=0&id=f5b28364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b28364",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VCard,VCol,VDialog,VFooter,VRow})
